module.exports = __webpack_public_path__ + "static/media/recently_Study@3x.dfabb298.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/channel/recently_Study@3x.png
// module id = 1875
// module chunks = 6